import React, { Fragment } from "react"
import { graphql } from "gatsby"
import SEO from "../components/SEO"
import Header from "../components/header"
import Main from "../components/main"
import Footer from "../components/footer"
import Nav from "../components/nav"
import Export from "../components/import-export/export"
import Import from "../components/import-export/import"

function ImportExportPage(props) {
  const site = props.data.site.siteMetadata

  return (
    <Fragment>
      <SEO
        title={`Import/Export | ${site.title}`}
        description={site.description}
        url={site.url}
        imgUrl={`${site.url}/index_banner_02.png`}
      />
      <Nav />
      <Header siteTitle={site.title} />
      <Main>
        <h2>Import / Export Your Progress</h2>

        <p>Since the app uses your in-browser database, if you end up switching to a different browser (for example, from Chrome to Safari), your progress will be lost! Below we provide a convenient way for you to transfer your progress from one browser to another.</p>

        <Export />
        <Import />
      </Main>
      <Footer />
    </Fragment>
  )
}

export const query = graphql`
  query ImportExportPageQuery {
    site {
      siteMetadata {
        title
        description
        url
      }
    }
  }
`

export default ImportExportPage
